export default __webpack_public_path__ + "static/media/ignition.fcb10ac1.svg";